/* unplugin-vue-components disabled */import script from "./Test.vue?vue&type=script&lang=ts&setup=true"
export * from "./Test.vue?vue&type=script&lang=ts&setup=true"

import "./Test.vue?vue&type=style&index=0&id=2bdd3984&scoped=true&lang=css"

import exportComponent from "D:\\Song\\Demo\\hxswmj\\hxswmj_vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bdd3984"]])

export default __exports__